const mockData: Record<string, any> = {
  'New Precertification': {
    veteranReferralId: 'VA0000001468',
    veteranIcn: '1013559275V055307',
    procedureCode: '70551',
    procedureCodesList: ['70470', '42140'],
    requestType: 'Outpatient',
    episodicCare: false,
  },
  'Veteran Demographics': {
    veteranFirstName: 'John',
    veteranLastName: 'Smith',
    veteranDob: new Date(1980, 12, 25),
    veteranGender: 'Male',
  },
  'Precertification Detail': {
    primaryDiagnosis: 'code1',
    secondaryDiagnosis: ['code2', 'code3', 'code4'],
    dateOfService: new Date(2025, 8, 13),
    bodyLocation: 'Left',
    quantity: '111',
    quantityType: 'Days',
    quantityTypeCode: 'DY',
    serviceTypeCode: '5',
    serviceType: 'Diagnostic Lab',
    placeOfService: 'Mobile Unit',
    placeOfServiceCode: '15',
  },
  'Rendering Provider': {
    providerNpi: '1234567890',
    providerName: 'Mary Jones',
    providerTypeCode: 'AS',
    providerType: 'Assistant Surgeon',
    specialTaxonomyCode: '01',
    specialTaxonomy: 'General Practice',
    facilityNpi: '1234567890',
    facilityName: '3T Imaging',
    facilityAddress: {
      street: '12345 Orange Street',
      street2: '',
      city: 'Seattle',
      state: 'Washington',
      zip: '98111',
    },
    providerEmail: 'someone@somehwere.com',
    serviceRender: false,
    secondaryAddress: {
      street: '12345 Apple Street',
      street2: '',
      city: 'Seattle',
      state: 'Washington',
      zip: '98111',
    },
  },
  'Clinical Notes': {
    clinicalNotes: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis risus lorem, dapibus et dolor ac, ornare hendrerit lacus. Curabitur et mauris sed felis pellentesque ornare. Curabitur semper ligula commodo orci egestas dignissim. Aliquam sed dui augue. Nullam quis nisl quis nunc maximus posuere consequat at odio. Duis imperdiet condimentum justo eget eleifend. Duis dignissim ut libero id tristique. Vivamus nunc nulla, sollicitudin id magna in, molestie ultrices lectus. Sed massa ligula, rutrum vel augue eget, dictum condimentum nibh. Cras ac urna ut magna tincidunt mattis at a magna. Donec dolor nunc, ullamcorper nec lorem vitae, ultricies malesuada ligula. Etiam a pretium lorem, et commodo lacus. Fusce id mauris vitae odio vehicula euismod ac quis dolor. Quisque molestie nisi erat, vitae mollis erat blandit a.

                Proin odio arcu, varius nec facilisis volutpat, aliquam nec urna. Donec vitae nibh eget nunc venenatis lobortis. Nam sollicitudin, dolor rhoncus luctus sagittis, massa quam maximus nibh, ac feugiat massa augue sit amet urna. Curabitur fermentum fringilla metus. Aliquam erat volutpat. Etiam ac purus vulputate, volutpat orci ac, sagittis ex. Praesent ac nisl tortor. Quisque tempus lorem elit, eget iaculis lacus eleifend in. Vivamus et congue diam, sed tempor quam. Integer eu velit nibh. Vestibulum non odio odio. Curabitur eros libero, tristique ac elit id, gravida volutpat dui. Suspendisse nisl ante, ullamcorper a metus ac, bibendum sagittis ex.`,
  },
  'Point of Contact': {
    pointOfContactFirstName: 'Eric',
    pointOfContactLastName: 'Jones',
    pointOfContactPhone: '800-555-1212',
    pointOfContactFax: '800-555-1313',
    pointOfContactEmail: 'someone@somehwere.com',
  },
};

export const stageData: Record<string, any> = {
  'Complete Form': { ...Object.assign({}, ...Object.values(mockData)) },
  ...mockData,
  'Bad ICN': {
    ...Object.assign({}, ...Object.values(mockData)),
    veteranIcn: '1234567890V123456',
  },
  Retrospective: {
    ...Object.assign({}, ...Object.values(mockData)),
    veteranReferralId: 'VA0000001202',
    veteranIcn: '1013559275V055307',
    dateOfService: new Date(2024, 3, 12),
  },
  'Expired Referral': {
    ...Object.assign({}, ...Object.values(mockData)),
    veteranReferralId: 'VA0000001202',
    veteranIcn: '1013559275V055307',
    dateOfService: new Date(2023, 5, 15),
  },
  'Multiple OHI': {
    ...Object.assign({}, ...Object.values(mockData)),
    veteranReferralId: 'VA0000001468',
    veteranIcn: '1013559275V055307',
  },
  'One OHI': {
    ...Object.assign({}, ...Object.values(mockData)),
    veteranReferralId: 'VA0000001485',
    veteranIcn: '1013604715V508563',
  },
  'No OHI': {
    ...Object.assign({}, ...Object.values(mockData)),
    veteranReferralId: 'VA0000001486',
    veteranIcn: '1013566712V260276',
  },
  'Bad Procedure Code': {
    ...Object.assign({}, ...Object.values(mockData)),
    procedureCode: '0007M',
  },
  'Complete with Procedure Codes': {
    ...Object.assign({}, ...Object.values(mockData)),
    procedureCode: '',
    procedureCodesList: ['70470', '42140'],
  },
  'Oracle Health Bypass': {
    ...Object.assign({}, ...Object.values(mockData)),
    veteranReferralId: 'VA0000007088',
    veteranIcn: '1013559275V055307',
    // This will be routed through an Oracle Health station (e.g., Ann Arbor MI - 506)
    // Processing will bypass OHI validation and route to FR with explanatory note
  },
};
